import { ArrowRightOutlined, PhoneOutlined, SafetyCertificateOutlined } from '@ant-design/icons'
import { Button, Col, Collapse, Form, Input, Modal, notification, Row, Select } from 'antd'
import { createRef, useEffect, useState } from 'react'
import ReCAPTCHA from 'react-google-recaptcha'
import { DeliverIcon, DeliveryIcon2, FastParcelIcon } from 'src/components/CustomIcon'
import * as api from 'src/configs/API'
import BASE_CONFIG from 'src/configs/base'
import addressServices from 'src/services/address.service'
import contactService from 'src/services/contact.service'
import { formatNumberWithCommas, toLowerCaseNonAccentVietnamese } from 'src/utils/common'
import { RULE_FORM } from 'src/utils/formValidation'
import request from 'src/utils/request'
const recaptchaRef = createRef()

const { Panel } = Collapse

const PriceItem = ({ data, index }) => (
	<div className="price-item">
		<div className="item-icon">{index == 0 && <FastParcelIcon />}</div>
		<div className="item-icon">{index == 1 && <DeliverIcon />}</div>
		<div className="item-icon">{(index == 2 || index == 3) && <DeliveryIcon2 />}</div>
		<div className="item-name">
			<span className="name-title">{data.serviceTypeName}</span>
			{/* <span className="name-desc">
				Thời gian dự kiến {moment(data.estimatedDateOfReceipt).format('DD/MM/YYYY')}
			</span> */}
		</div>
		<div className="item-price">
			<span className="price-mb__label" style={{ display: 'none' }}>
				Tổng giá:
			</span>
			<span className="price-amount">{formatNumberWithCommas(data.totalFee)} VND</span>
		</div>
	</div>
)

const PriceModal = ({ data, visibled, onClose }) => {
	const [form] = Form.useForm()

	const [isContact, setIsContact] = useState(false)
	const [isSuccess, setIsSuccess] = useState(false)
	const [isLogin, setIsLogin] = useState(false);

	const [wardId, setWardId] = useState(null)
	const [provinceId, setProvinceId] = useState(null)
	const [isCanCreate, setIsCanCreate] = useState(false)
	const [address, setAddress] = useState("")
	const [token, setToken] = useState('')
	const [listProvince, setListProvince] = useState([])
	const [listWard, setListWard] = useState([])

	const getProvincesByCountryID = () => {
		addressServices
			.queryCitiesByCountryID("VN")
			.then((response) => {
				setListProvince(response?.provinces)
			})
			.catch(console.log)
	}
	const getWardsByProvinceID = (provinceID) => {
		addressServices
			.queryWards(provinceID + provinceID)
			.then((response) => {
				setListWard(response?.wards)
			})

			.catch(console.log)
	}

	useEffect(() => {
		getProvincesByCountryID();
	}, [])
	const handleClose = () => {
		setIsSuccess(false)
		setIsContact(false)
		onClose()
	}
	useEffect(() => {
		const user = localStorage.getItem('user')
		setIsLogin(user ? true : false)
	}, [])
	const handleSubmitContact = (values) => {
		if (!token || token === '') {
			notification.error({
				message: 'Vui lòng xác thực ReCAPTCHA!',
			})
			return;
		}
		if (!provinceId) {
			notification.error({
				message: 'Vui lòng chọn tỉnh thành',
			})
		}
		if (!wardId) {
			notification.error({
				message: 'Vui lòng chọn phường xã',
			})
		}
		//values.content = '[Lấy thông tin báo giá]'
		values.provinceId = provinceId;
		values.wardId = wardId;
		values.formId = 'price_contact_form';
		values.buttonId = 'price_contact';
		contactService
			.insertContactPushtoCRMLead(values, { 'TokenRecaptcha': token })
			.then((response) => {
				if (!response.isError) {
					setIsSuccess(true)
				}
			})
			.catch(() => {
				handleClose()
				notification.error({
					message: 'Lỗi!',
					description: 'Có lỗi xảy ra, vui lòng thử lại sau!',
				})
			})
	}
	const analysisAddress = () => {
		request
			.pmsApi({
				url: api.PMS_APIs.API_CHECK_ADDRESS + '?address=' + encodeURIComponent(address),
				method: 'GET',
			})
			.then((response) => {

				if (response.isOk) {
					form.setFieldValue('province', response.provinceName);
					form.setFieldValue('ward', response.wardName);
					setProvinceId(response.provinceID);
					setWardId(response.wardID);
					setIsCanCreate(true);
				} else {
					form.setFieldValue('province', "");
					form.setFieldValue('ward', "");
					setProvinceId("");
					setWardId("");
					setIsCanCreate(false);
					notification.error({
						message: 'Địa chỉ không hợp lệ, vui lòng nhập lại!',
					})
				}
			})
			.catch(console.log)
	}
	const ContactForm = (
		<div className="price__modal-contact__form">
			{/* eslint-disable-next-line @next/next/no-img-element */}

			<div className="contact__form-form">

				<Form onFinish={handleSubmitContact} scrollToFirstError form={form}>
					<Row>
						<Col span={24}>
							<span style={{ fontSize: 16, fontWeight: 600, color: "#CC0000" }}><img src='/images/contact-form/hands.png' style={{ width: 21 }}></img> Đăng ký tư vấn - điền ngay!</span>
						</Col>
					</Row>
					<Row>
						<Col span={24}>	<Form.Item
							rules={[
								{ required: true, message: 'Vui lòng nhập tên' },
								{ whitespace: true, message: 'Vui lòng nhập tên' },
							]}
							style={{ marginTop: 12 }}
							name="name"
						>
							<div className="ph-wrap">
								<Input
									size='small'
									placeholder=" "
									prefix={<img src="/images/contact-form/userprefix.png" style={{ width: 21, height: 21 }} />}
									className="ph-input"
								/>

								<span className="ph-fake">
									Họ và tên người liên hệ<span className="req">*</span>
								</span>
							</div>
						</Form.Item></Col>
						<Col span={24}>	<Form.Item rules={RULE_FORM.PHONE_NUMBER} style={{ marginTop: 12 }} name="phone">
							{/* <Input placeholder="Số điện thoại" /> */}
							<div className="ph-wrap">
								<Input
									size='small'
									placeholder=" "
									prefix={<img src="/images/contact-form/phoneprefix.png" style={{ width: 21, height: 21 }} />}
									className="ph-input"
								/>

								<span className="ph-fake">
									Số điện thoại <span className="req">*</span>
								</span>
							</div>
						</Form.Item></Col>
						<Col span={24}>	<Form.Item
							rules={[{ type: 'email', message: 'Email không đúng định dạng!' }]}
							style={{ marginTop: 12 }}
							name="email"
						>
							{/* <Input placeholder="Email" /> */}
							<div className="ph-wrap">
								<Input
									size='small'
									placeholder=" "
									prefix={<img src="/images/contact-form/mailprefix.png" style={{ width: 21, height: 21 }} />}
									className="ph-input"
								/>

								<span className="ph-fake">
									Email
								</span>
							</div>
						</Form.Item></Col>

						<Col span={24}>

							<Form.Item
								rules={[{ required: true, message: 'Vui lòng chọn tỉnh thành' }]}
								style={{ marginTop: 12 }}
								name="province"
							>
								<div className={`fp-wrap ${provinceId ? "fp-has-value" : ""}`}>
									<div className="fp-select-inner fp-select-inner-modify">
										<Select
											showSearch
											placeholder=""
											optionFilterProp="children"
											filterOption={(input, option) =>
												toLowerCaseNonAccentVietnamese(option.children.toLowerCase()).includes(
													toLowerCaseNonAccentVietnamese(input.toLowerCase())
												)
											}
											suffixIcon={<img src="/images/contact-form/teleprefix.png" style={{ width: 21, height: 21 }} />}
											onChange={(value) => {
												form.setFieldValue('ward', null);
												setProvinceId(value);
												form.setFieldsValue({
													province: value
												});
												getWardsByProvinceID(value);
											}}
										>
											{listProvince?.map((item) => (
												<Select.Option key={item.provinceID} value={item.provinceID}>
													{item.provinceName}
												</Select.Option>
											))}
										</Select>
									</div>
									<span className="fp-placeholder" style={{ marginLeft: 28 }}>
										Tỉnh/Thành Phố <span className="fp-star">*</span>
									</span>
								</div>

							</Form.Item>

						</Col>
						<Col span={24}>
							<Form.Item
								rules={[
									{ required: true, message: 'Vui lòng chọn phường xã' },
								]}
								style={{ marginTop: 12 }}
								name="ward"
							>
								<div className={`fp-wrap ${wardId ? "fp-has-value" : ""}`}>
									<div className="fp-select-inner fp-select-inner-modify">
										<Select
											showSearch
											suffixIcon={<img src="/images/contact-form/teleprefix.png" style={{ width: 21, height: 21 }} />}
											optionFilterProp="children"
											filterOption={(input, option) =>
												toLowerCaseNonAccentVietnamese(option.children.toLowerCase()).indexOf(
													toLowerCaseNonAccentVietnamese(input.toLowerCase())
												) >= 0
											}
											onChange={e => {
												setWardId(e);
												form.setFieldsValue({
													ward: e
												})
											}}
										>
											{listWard?.map((item) => (
												<Select.Option value={item?.wardID} key={item?.wardID}>
													{item?.wardName}
												</Select.Option>
											))}
										</Select>
									</div>
									<span className="fp-placeholder" style={{ marginLeft: 28 }}>
										Phường/xã <span className="fp-star">*</span>
									</span>
								</div>

							</Form.Item>
						</Col>
						{/* <Col span={24}><Form.Item
							rules={[{ required: true, message: 'Vui lòng nhập địa chỉ chi tiết!' }]}
							style={{ marginTop: 12 }}
							name="content"
						>
							
							<div className="ph-wrap">
								<Input
									size='small'
									placeholder=" "
									prefix={<img src="/images/contact-form/teleprefix.png" style={{ width: 21, height: 22 }} />}
									className="ph-input"
									onChange={(e) => {
										setAddress(e.target.value);
									}}
								/>

								<span className="ph-fake">
									Địa chỉ công ty chi tiết <span className="req">*</span>
								</span>
							</div>
						</Form.Item>
						</Col> */}
						<Col span={24}>
							<Form.Item
								name="Captcha"
								style={{
									marginTop: 18,
								}}
							>
								<ReCAPTCHA
									sitekey={api.SITE_KEY}
									onChange={(token) => setToken(token)}
									onExpired={(token) => setToken('')}
									ref={recaptchaRef}
									hl={'vi'}
								/>
							</Form.Item>
						</Col>
					</Row>
					<Row>
						<Col span={24}>
							<p style={{ fontSize: 13, margin: "20px 0px" }}>
								<SafetyCertificateOutlined />
								&nbsp; Bằng việc gửi thông tin, bạn đồng ý với
								<a href="https://247express.vn/chinh-sach-bao-mat"> chính sách bảo mật </a>của chúng tôi.{' '}
							</p>
						</Col>
					</Row>
					<Row gutter={16} className="form-btns">
						<Col span={24}>
							<Button
								style={{ width: '100%', height: 44, fontSize: 16, lineHeight: '24px' }}
								type="primary"
								htmlType="submit"
							>
								Nhận Tư Vấn Ngay <ArrowRightOutlined />
							</Button>
						</Col>
					</Row>
					<Row>
						<Col span={24} style={{ textAlign: 'center', marginTop: 12 }}>
							<i>Bạn không phải là Khách hàng Doanh nghiệp? Tìm hiểu thêm <a href='https://247express.vn/tin-tuc/tin-tuc-va-su-kien/huong-dan-gui-hang-danh-cho-khach-hang-le/759?utm_source=LDPd'>tại đây</a>.</i>
						</Col>
					</Row>
					<Row gutter={[16, 12]} align="middle" justify="space-between">
						{/* Cột mascot: ẩn ở mobile (xs=0) */}
						<Col xs={0} md={6}>
							<img src="/images/contactform_img.png" alt="Liên hệ" style={{ maxWidth: "100%", height: "auto" }} />
						</Col>

						{/* 3 feature items: mỗi item chiếm 8/24 ở mobile -> 3 item vừa hàng, desktop giữ 6/24 */}
						<Col xs={8} md={6} style={{ textAlign: "center", display: "flex", flexDirection: "column", gap: 8 }}>
							<img style={{ width: 42, height: 42 }} src="/images/contact-form/star.png" alt="20k+" />
							<span>20.000+ khách hàng<br />doanh nghiệp</span>
						</Col>

						<Col xs={8} md={6} style={{ textAlign: "center", display: "flex", flexDirection: "column", gap: 8 }}>
							<img style={{ width: 42, height: 42 }} src="/images/contact-form/delivery-done.png" alt="Giao nhanh" />
							<span>Giao nhanh<br />toàn quốc</span>
						</Col>

						<Col xs={8} md={6} style={{ textAlign: "center", display: "flex", flexDirection: "column", gap: 8 }}>
							<img style={{ width: 42, height: 42 }} src="/images/contact-form/box.png" alt="Quản lý đơn" />
							<span>Quản lý đơn hàng<br />thông minh</span>
						</Col>
					</Row>

				</Form>
			</div>
		</div>
	)
	const ContactSuccess = (
		<div className="price__modal-success">
			<img src="/images/contactform_img.png" alt="Liên hệ thành công" />
			<h1 style={{ textAlign: 'center', fontSize: 40, fontWeight: 'bold', lineHeight: "48px" }}>Cảm ơn bạn đã tin tưởng và liên hệ với 247Express!</h1>
			<p style={{ color: '#5E6278', textAlign: 'center' }}>
				Thông tin của bạn đã được chuyển đến bộ phận tiếp nhận. Đội ngũ của chúng tôi sẽ liên hệ để tư vấn giải pháp phù hợp nhất theo nhu cầu vận chuyển của bạn trong vòng 4 giờ làm việc (trừ chủ nhật & ngày lễ).
			</p>
		</div>
	)
	const PriceFooter = (
		<div className="price__modal-footer">
			<span style={{ textAlign: 'left', fontSize: 15 }}>Liên hệ với chúng tôi để được báo giá tốt hơn</span>
			{!isLogin &&
				<Button onClick={() => setIsContact(true)} type="primary">
					Liên hệ
				</Button>
			}
			{isLogin &&
				<>
					<Button onClick={() => {
						window.open(`tel:${BASE_CONFIG.HOTLINE}`);
					}} type="primary" icon={<PhoneOutlined />}>
						{BASE_CONFIG.HOTLINE}
					</Button>
					<Button onClick={() => {
						document.getElementById("chat-icon").click();
					}} type="primary">
						Hỗ trợ
					</Button>
				</>
			}
		</div>
	)

	const PriceData = (
		<div className="price__modal-container">
			<Collapse expandIconPosition="end">
				{data?.map((e, index) => (
					<Panel header={<PriceItem data={e} index={index} />} key={index}>
						<div className="price__item-detail">
							<div className="detail-field">
								<span className="field-key">Cước chính</span>
								<span className="field-value">{formatNumberWithCommas(e.price) || 0}đ</span>
							</div>
							<div className="detail-field">
								<span className="field-key">Phí nhiên liệu</span>
								<span className="field-value">{formatNumberWithCommas(e.fuelFee) || 0}đ</span>
							</div>
							<div className="detail-field">
								<span className="field-key">Phí VAT</span>
								<span className="field-value">{formatNumberWithCommas(e.vatFee) || 0}đ</span>
							</div>
							<div className="detail-field">
								<span className="field-key">Phí ngoại thành</span>
								<span className="field-value">{formatNumberWithCommas(e.farFee) || 0}đ</span>
							</div>
							<div className="detail-field">
								<span className="field-key">Phí dịch vụ gia tăng</span>
								<span className="field-value">
									{formatNumberWithCommas(e.totalServiceFee) || 0}đ
								</span>
							</div>
						</div>
					</Panel>
				))}
			</Collapse>
		</div>
	)

	const currentContent = isContact ? (isSuccess ? ContactSuccess : ContactForm) : PriceData

	const currentTitle = isContact ? (
		isSuccess ? (
			'Cảm ơn quý khách'
		) : (
			'Liên hệ'
		)
	) : (
		'Tính giá tham khảo'
	)

	return (
		<div className="price__modal">
			<Modal
				destroyOnClose
				open={true}
				centered
				getContainer=".price__modal"
				width={650}
				title={isSuccess ? null :
					<div
						style={{
							color: '#181C32',
							textAlign: 'center',
							fontSize: 20,
							lineHeight: '32px',
							fontWeight: 600,
						}}
					>
						{currentTitle}
					</div>
				}
				footer={!isContact && PriceFooter}
				onCancel={handleClose}
				style={{
					borderRadius: 16,
					overflow: 'hidden',

				}}

			>
				{currentContent}
			</Modal>
		</div>
	)
}

export default PriceModal
